'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _frontendUtils = require('@import/frontend-utils');
var _validationUtils = require('@import/validation-utils');
var ValidationUtils = _interopRequireWildcard(_validationUtils);
var _BaseApi2 = require('../BaseApi');
var _BaseApi3 = _interopRequireDefault(_BaseApi2);
var _ParameterError = require('../ParameterError');
var _ParameterError2 = _interopRequireDefault(_ParameterError);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var RunApi = function (_BaseApi) {
  (0, _inherits3.default)(RunApi, _BaseApi);
  function RunApi() {
    (0, _classCallCheck3.default)(this, RunApi);
    return (0, _possibleConstructorReturn3.default)(this, (RunApi.__proto__ || Object.getPrototypeOf(RunApi)).call(this, _frontendUtils.endpoints.runBaseUrl));
  }
  (0, _createClass3.default)(RunApi, [{
    key: 'start',
    value: function start(extractorId, loginSessionId) {
      var concurrent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var inputId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
      if (!ValidationUtils.isGuid(extractorId)) {
        return Promise.reject(new _ParameterError2.default('extractorId', extractorId, 'guid string.'));
      }
      var request = {
        method: 'POST',
        url: extractorId + '/start'
      };
      if (loginSessionId) {
        request.queryParameters = {
          loginSessionId: loginSessionId,
          concurrent: concurrent
        };
      } else if (concurrent === true) {
        request.queryParameters = {
          concurrent: concurrent
        };
      }
      if (inputId) {
        if (!request.queryParameters) request.queryParameters = {};
        request.queryParameters.inputId = inputId;
      }
      return this.makeRequest(request);
    }
  }, {
    key: 'startAdvanced',
    value: function startAdvanced(body) {
      if (!ValidationUtils.isObject(body)) {
        return Promise.reject(new _ParameterError2.default('body', body, 'JS object.'));
      }
      if (!ValidationUtils.isArrayOf(ValidationUtils.isObject, body.extractors)) {
        return Promise.reject(new _ParameterError2.default('extractors', body.extractors, 'array of objects.'));
      }
      return this.makeRequest({
        method: 'POST',
        url: 'crawl/start',
        body: body
      });
    }
  }, {
    key: 'cancel',
    value: function cancel(extractorId) {
      var crawlRunId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (!ValidationUtils.isGuid(extractorId)) {
        return Promise.reject(new _ParameterError2.default('extractorId', extractorId, 'guid string.'));
      }
      if (crawlRunId && !ValidationUtils.isGuid(crawlRunId)) {
        return Promise.reject(new _ParameterError2.default('crawlRunId', crawlRunId, 'guid string.'));
      }
      var queryParameters = void 0;
      if (crawlRunId) {
        queryParameters = {
          crawlRunId: crawlRunId
        };
      }
      return this.makeRequest({
        method: 'POST',
        url: extractorId + '/cancel',
        queryParameters: queryParameters
      });
    }
  }]);
  return RunApi;
}(_BaseApi3.default);
exports.default = RunApi;